import React, { Component } from "react";
import { connect } from "react-redux";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@revvsales/components";
import FormModeField from "./FormModeField";
import SignatureContainer from "../../DocumentItems/SignatureContainer";
import StripePaymentContainer from "../../DocumentItems/StripePaymentContainer";
import { DOCUMENTS } from "../../../constants";

// Assets Import
import noFields from "../../../assets/empty state image for form window.png";

import StatusBar from "./StatusBar";

// Action Imports
import { updateStatusFormField } from "../../../actions/DocumentActions";

// Destructuring
const { DOCUMENT_COMPONENT_TYPES } = DOCUMENTS;

class FormView extends Component {
  state = {
    completedCount: 0,
    formRight: null,
    formDisplay: "none",
    currentOpenField: "",
  };

  componentDidMount() {
    setTimeout(() => {
      this._setFormPosition();
    }, 25);
  }

  componentDidUpdate(prevProps) {
    if (this.props.formCanRender && !prevProps.formCanRender) {
      this._setFormPosition();
    }
  }

  _setFormPosition = () => {
    const ele = document.getElementById("document-view-container");
    if (ele) {
      const { left } = ele.getBoundingClientRect();
      const { clientWidth } = document.documentElement;
      let right = Math.round(clientWidth - left);
      if (right > clientWidth - 450) {
        right = clientWidth - 450;
      }
      setTimeout(() => {
        this.setState({
          formRight: right,
          formDisplay: "block",
        });
      }, 300);
    }
  };

  _handleCompletedCount = val => {
    if (val) {
      this.setState(prevState => ({
        completedCount: prevState.completedCount + 1,
      }));
    } else {
      this.setState(prevState => ({
        completedCount: prevState.completedCount - 1,
      }));
    }
  };

  _setCurrentField = fieldID => {
    this.setState({ currentOpenField: fieldID });
  };

  _handleCountValueOfFormField = () => {
    let fillerCountValue = 0;
    let totalCount = this.props.docForm.length;
    if (
      this.props.sharingHash &&
      (this.props.recipientType === "FILLER_AND_SIGNER" ||
        this.props.recipientType === "FILLER" ||
        this.props.recipientType === "SIGNER")
    ) {
      const unfilledValue = [];

      this.props.docForm.forEach(element => {
        if (element.filler_type === "RECIPIENT") {
          unfilledValue.push(element);
        }
        if (
          element.filler_type === "RECIPIENT" &&
          (element.value &&
            typeof element.value !== "object" &&
            element.value.length !== 0)
        ) {
          fillerCountValue += 1;
        } else if (
          element.filler_type === "RECIPIENT" &&
          element.value &&
          typeof element.value === "object"
        ) {
          let tempValue = 0;
          Object.keys(element.value).map(k => {
            if (element.value[k] !== "") tempValue += 1;
            return tempValue;
          });
          if (tempValue === Object.keys(element.value).length) {
            fillerCountValue += 1;
          }
        }
      });
      totalCount = unfilledValue.length;
    } else {
      fillerCountValue =
        this.state.completedCount < 0
          ? 0
          : this.state.completedCount ||
            (this.state.completedCount > this.props.docForm.length
              ? this.props.docForm.length
              : this.state.completedCount) / this.props.docForm.length;
    }
    return { fillerCountValue, totalCount };
  };

  render() {
    const { docForm, formTop } = this.props;
    const { formDisplay, formRight, currentOpenField } = this.state;
    const style = {
      top: formTop,
      right: formRight,
      display: formDisplay,
    };
    // const userSignUpInfo = readDataFromLocalStorage("userSignUpInfo");
    const subFillerTextHead = (
      <p>
        Tip: You can assign fields to recipients by checking the &nbsp;
        <b>
          <i>Assign to recipient </i>
        </b>
        checkbox in each form card. Recipients can fill them when you send a
        document for eSign.
      </p>
    );
    const {
      fillerCountValue,
      totalCount,
    } = this._handleCountValueOfFormField();
    // const subFillerTextHead = `Tip: You can assign fields to recipients by checking the <i>Assign to recipient</i> checkbox in each form card. Recipients can fill them when you send a document for eSign.`;
    return (
      <div
        className={`form-view-wrapper ${
          !this.props.show ? "document-view-visiblity-hidden" : ""
        }`}
        style={style}>
        <div className="back-doc-view">
          <Button
            className="back-to-doc"
            onClick={this.props.formView}
            data-test="formview-back-document-btn">
            <i>
              <FontAwesomeIcon icon={["far", "arrow-left"]} />
            </i>
            Back to document
          </Button>
        </div>
        <div
          className={`doc-form-mode-wrapper ${
            this.props.isDocBandAvailabel ? "reduce-height-for-band" : ""
          } `}>
          <div className="formtitle-wrapper">
            <div className="document-sections-formtitle">
              {/* <div>
                <FontAwesomeIcon icon={["far", "check"]} />
              </div> */}
              <div>
                <span
                  className="image-form-align"
                  role="img"
                  aria-label="bolt-icon">
                  ⚡️
                </span>
                Fill this form to complete the document
              </div>
            </div>
            <div
              data-test="form-close-icon"
              className="close-icon"
              role="button"
              tabIndex="0"
              onClick={this.props.formView}
              onKeyPress={() => {}}>
              <FontAwesomeIcon icon={["far", "times-circle"]} />
            </div>
          </div>
          {/* <div className="formtitle-wrapper"> */}
          <div
            className={`form-subtitle-wrapper ${
              this.props.isSharedDocument
                ? "shared-document-subtext-wrapper"
                : ""
            }`}>
            Click on a field card below to open and fill it. <br />
            {!this.props.isSharedDocument
              ? subFillerTextHead
              : "Click Submit when done"}
          </div>
          {/* </div> */}
          {docForm.length > 0 && (
            <div className="status-wrapper">
              <div className="status">
                <strong>
                  {/* {(this.state.completedCount < 0
                    ? 0
                    : this.state.completedCount) ||
                    (this.state.completedCount > docForm.length
                      ? docForm.length
                      : this.state.completedCount)}
                  /{docForm.length} */}
                  {fillerCountValue}/{totalCount}
                </strong>
                &nbsp; Fields filled
              </div>
              <StatusBar
                completedCount={fillerCountValue}
                totalCount={totalCount}
              />
            </div>
          )}

          <div className="document-sections-questions" id="form-view-area">
            {docForm.length === 0 && !this.props.signatureData.length && (
              <div className="image-section">
                <img src={noFields} alt="No fields" />
                <p>
                  No form fields to fill here. The template from which you
                  created this document does not have any fillable form fields
                  in it
                </p>
              </div>
            )}
            {Array.isArray(docForm) &&
              docForm.length > 0 &&
              docForm.map((item, index) => (
                <FormModeField
                  {...item}
                  sNo={index + 1}
                  key={item.id}
                  handleCompletedCount={this._handleCompletedCount}
                  currentOpenField={currentOpenField}
                  setCurrentField={this._setCurrentField}
                  sharingHash={this.props.sharingHash}
                  isSharedDocument={this.props.isSharedDocument}
                  docID={this.props.docID}
                  setToggleCheckbox={this._setToggleCheckbox}
                  assignRecepient={this.state.assignRecepient}
                />
              ))}

            {this.props.signatureData &&
              this.props.signatureData.length > 0 &&
              this.props.signatureData.map(sectionData => (
                <div
                  className="form-mode-field-signer-content"
                  id={sectionData.sectionID}>
                  <SignatureContainer
                    {...sectionData}
                    isLocked={this.props.isLocked}
                  />
                </div>
              ))}
            {this.props.stripeData &&
              this.props.stripeData.length > 0 &&
              this.props.stripeData.map(sectionData => (
                <div
                  className="form-mode-field-signer-content"
                  id={sectionData.sectionID}>
                  <StripePaymentContainer {...sectionData} />
                </div>
              ))}

            <div className="form-mob-done">
              <Button
                data-test="formview-done-btn"
                className="mob-done"
                onClick={this.props.formView}>
                Done
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    document: { fields_used: docForm, isLocked },
  } = state.DocumentStore;
  const { components = {} } = state.DocumentStore;
  const { recipientType } = state.SharedDocument;

  // get signature data
  const signatureData = components
    ? Object.keys(components)
        .filter(
          componentId =>
            components[componentId] &&
            components[componentId].content &&
            components[componentId].content.type ===
              DOCUMENT_COMPONENT_TYPES.EMPTY_SIGNATURE_CONTAINER,
        )
        .map(componentId => ({
          sectionID: componentId,
          mode: "DOCUMENT",
        }))
    : [];

  // get stripe data
  const stripeData = components
    ? Object.keys(components)
        .filter(
          componentId =>
            components[componentId] &&
            components[componentId].content &&
            components[componentId].content.type ===
              DOCUMENT_COMPONENT_TYPES.STRIPE_PAYMENT_BUTTON,
        )
        .map(componentId => ({
          sectionID: componentId,
          mode: "DOCUMENT",
        }))
    : [];

  return { docForm, signatureData, stripeData, isLocked, recipientType };
};

const mapDispatchToProps = {
  updateStatusFormField,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FormView);



// WEBPACK FOOTER //
// ./src/components/DocumentV2/FormView/FormView.js